/**
 * Demo credentials are no longer hard-coded in client source.
 * They are fetched from the public backend endpoint /api/demo/credentials,
 * which returns the seeded demo accounts (used to power the click-to-login
 * cards on the public login pages). The endpoint is deliberately public —
 * these are demo accounts that gate access to a synthetic dataset only.
 */
import { api } from "./api";

let _cache = null;

export const fetchDemoCredentials = async () => {
  if (_cache) return _cache;
  try {
    const r = await api.get("/demo/credentials");
    _cache = r.data || { portal: [], crown: {} };
  } catch {
    _cache = { portal: [], crown: {} };
  }
  return _cache;
};
